import { htmlElem } from './globals';
import { header } from '../components/navigation';
import { getDocumentProperties } from './getDocumentProperties';

const resetResponsive = () => {
    let { mobile } = getDocumentProperties();
    if (!mobile) {
        htmlElem.classList.remove('navigation__open');
        header.classList.remove('menu__open')
    }
};

export {
    resetResponsive
}